import { useRef, useState } from "react";
import { Smile } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import SpellcheckTextarea from "@/components/SpellcheckTextarea";
import { WORKSPACE_CHAT_EMOJIS } from "@/lib/workspaceChat";

export default function MessageEmojiTextarea({
  label = "Texto del mensaje",
  value,
  onChange,
  placeholder = "",
  minHeightClass = "min-h-[120px]",
  testId = "message-emoji-textarea",
  enableSpellcheck = true,
}) {
  const textareaRef = useRef(null);
  const [showEmoji, setShowEmoji] = useState(false);

  const insertEmoji = (emoji) => {
    const el = textareaRef.current;
    const current = String(value || "");
    if (!el) {
      onChange(`${current}${emoji}`);
      return;
    }
    const start = el.selectionStart ?? current.length;
    const end = el.selectionEnd ?? start;
    const next = `${current.slice(0, start)}${emoji}${current.slice(end)}`;
    onChange(next);
    requestAnimationFrame(() => {
      el.focus();
      const pos = start + emoji.length;
      el.setSelectionRange(pos, pos);
    });
  };

  return (
    <div className="space-y-1.5" data-testid={testId}>
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <Label className="text-xs">{label}</Label>
        <Button
          type="button"
          variant="outline"
          size="sm"
          className="rounded-sm h-7 text-[11px]"
          onClick={() => setShowEmoji((v) => !v)}
          data-testid={`${testId}-emoji-toggle`}
          aria-label="Insertar emoji"
        >
          <Smile className="h-3.5 w-3.5 mr-1" aria-hidden />
          Emoji
        </Button>
      </div>
      {showEmoji ? (
        <div
          className="flex flex-wrap gap-1 rounded-sm border border-slate-200 bg-white p-2"
          data-testid={`${testId}-emoji-bar`}
        >
          {WORKSPACE_CHAT_EMOJIS.map((emoji) => (
            <button
              key={emoji}
              type="button"
              className="text-lg leading-none p-1 rounded hover:bg-slate-100"
              onClick={() => insertEmoji(emoji)}
              aria-label={`Insertar ${emoji}`}
            >
              {emoji}
            </button>
          ))}
        </div>
      ) : null}
      <SpellcheckTextarea
        ref={textareaRef}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className={`rounded-sm text-sm ${minHeightClass}`}
        enableSpellcheck={enableSpellcheck}
        showSuggestionBar={enableSpellcheck}
        testId={`${testId}-field`}
      />
    </div>
  );
}
